import { Theme as MuiTheme } from '@mui/material';

interface Theme extends MuiTheme {
    mode?: 'light' | 'dark';
}

export function isLightMode(theme: Theme) {
    return theme.mode === 'light';
}

export function isDarkMode(theme: Theme) {
    return theme.mode === 'dark';
}
